const AUTH_EVENT_NAMESPACE = '.workplaceAuth'

function applyTheme(theme) {
    const isDark = theme === 'dark'
    const $darkModeButton = jQuery('#darkMode')

    jQuery('html').attr({
        'data-bs-theme': theme,
        'data-color-scheme': theme
    })
    $darkModeButton.attr('data-bs-theme', theme)
    $darkModeButton.find('span').text(
        $darkModeButton.attr(isDark ? 'data-lightmode-text' : 'data-darkmode-text')
    )
    $darkModeButton.find('i')
        .toggleClass('ico-sun-light-outline', isDark)
        .toggleClass('ico-moon-dark-outline', !isDark)

    if (window.gon) window.gon.cwwTheme = theme
}

function initializePasswordStrengthChecker() {
    const $passwordInput = jQuery('input[id*="password"]:not([id*="confirmation"]):not([class*="skip-checker"])')
    const $passwordConfirmationInput = jQuery('input[id*="password_confirmation"]')
    const $tooltip = jQuery('#passwordStrengthTooltip')
    const $bar = jQuery('#passwordStrengthBar')
    const $confirmationRule = $tooltip.find('.pwd-confirmation')
    const $strengthRules = $tooltip.find('li:not(.pwd-confirmation)')

    if (!$passwordInput.length || !$tooltip.length || !$bar.length) return

    const checkStrength = (password) => {
        const rules = {
            length: password.length >= 6,
            capital: /[A-Z]/.test(password),
            number: /[0-9]/.test(password),
            special: /[^A-Za-z0-9]/.test(password)
        }
        const passed = Object.values(rules).filter(Boolean).length
        let width = (passed / 4) * 100

        if (password.length > 0 && width === 0) width = 12

        const color = ['var(--bs-danger)', 'var(--bs-warning)', 'var(--bs-warning)', 'var(--bs-success)'][passed - 1] || 'var(--bs-danger)'
        $bar.css({ width: `${width}%`, backgroundColor: color })

        Object.entries(rules).forEach(([rule, rulePassed]) => {
            $tooltip.find(`.rule-${rule}`).toggleClass('active', rulePassed)
        })
    }

    const showTooltip = ($input) => {
        $tooltip
            .removeClass('d-none')
            .css({ top: 'calc(100% + 0.5rem)', left: 0, width: '100%', position: 'absolute' })
            .appendTo($input.closest('.form-group'))
    }

    $passwordInput
        .off(`input${AUTH_EVENT_NAMESPACE} focus${AUTH_EVENT_NAMESPACE}`)
        .on(`input${AUTH_EVENT_NAMESPACE} focus${AUTH_EVENT_NAMESPACE}`, (event) => {
            const $input = jQuery(event.currentTarget)

            $bar.parent().removeClass('d-none')
            $strengthRules.removeClass('d-none')
            $confirmationRule.addClass('d-none')
            checkStrength($input.val())
            showTooltip($input)
        })

    $passwordConfirmationInput
        .off(`input${AUTH_EVENT_NAMESPACE} focus${AUTH_EVENT_NAMESPACE}`)
        .on(`input${AUTH_EVENT_NAMESPACE} focus${AUTH_EVENT_NAMESPACE}`, (event) => {
            const $input = jQuery(event.currentTarget)
            const original = $passwordInput.val()
            const confirmation = $input.val()

            if (!original) return

            $bar.parent().addClass('d-none')
            $strengthRules.addClass('d-none')
            $confirmationRule.removeClass('d-none')

            if (confirmation && original === confirmation) {
                $confirmationRule
                    .addClass('active')
                    .find('.not-match').addClass('d-none').end()
                    .find('.do-match').removeClass('d-none')
            } else {
                $confirmationRule
                    .removeClass('active')
                    .find('.do-match').addClass('d-none').end()
                    .find('.not-match').removeClass('d-none')
            }

            showTooltip($input)
        })

    $passwordInput
        .add($passwordConfirmationInput)
        .off(`blur${AUTH_EVENT_NAMESPACE}`)
        .on(`blur${AUTH_EVENT_NAMESPACE}`, () => $tooltip.addClass('d-none'))
}

function initializeAuthPage() {
    const $darkModeButton = jQuery('#darkMode')
    const savedTheme = localStorage.getItem('last_CWWtheme_setting')
    const savedAccessibility = localStorage.getItem('last_cwwAccessibility_setting')

    if (savedTheme === 'light' || savedTheme === 'dark') applyTheme(savedTheme)

    if (savedAccessibility) {
        const togglerMap = { default: 'standard', small: 'smaller', big: 'bigger' }
        jQuery('html').attr('data-accessibility', savedAccessibility)
        jQuery('li #accessToggler').removeClass('current')
        jQuery(`#accessToggler[data-access-toggler="${togglerMap[savedAccessibility]}"]`).addClass('current')
    }

    $darkModeButton
        .off(`click${AUTH_EVENT_NAMESPACE}`)
        .on(`click${AUTH_EVENT_NAMESPACE}`, function(event) {
            event.preventDefault()
            const theme = jQuery('html').attr('data-bs-theme') === 'dark' ? 'light' : 'dark'
            applyTheme(theme)
            localStorage.setItem('last_CWWtheme_setting', theme)
        })

    jQuery('li #accessToggler')
        .off(`click${AUTH_EVENT_NAMESPACE}`)
        .on(`click${AUTH_EVENT_NAMESPACE}`, function(event) {
            event.preventDefault()
            const accessValueMap = { smaller: 'small', standard: 'default', bigger: 'big' }
            const toggler = jQuery(this).attr('data-access-toggler')
            const accessibility = accessValueMap[toggler] || 'default'

            jQuery('li #accessToggler').removeClass('current')
            jQuery(this).addClass('current')
            jQuery('html').attr('data-accessibility', accessibility)
            localStorage.setItem('last_cwwAccessibility_setting', accessibility)
        })

    jQuery('[id="showPassword"]')
        .off(`click${AUTH_EVENT_NAMESPACE}`)
        .on(`click${AUTH_EVENT_NAMESPACE}`, function() {
            const $input = jQuery(jQuery(this).attr('toggle'))
            jQuery(this).toggleClass('fa-eye-slash fa-eye')
            $input.attr('type', $input.attr('type') === 'password' ? 'text' : 'password')
        })

    initializePasswordStrengthChecker()

    jQuery('input, textarea').each(function() {
        const $input = jQuery(this)
        if (!$input.prop('required') && $input.val() !== '') $input.addClass('notempty')
    })

    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(element) {
        window.bootstrap.Tooltip.getOrCreateInstance(element)
    })

    jQuery('.loader').fadeOut()
    jQuery('#preloader').delay(150).fadeOut('slow')
}

jQuery(document)
    .off(`turbolinks:load${AUTH_EVENT_NAMESPACE}`)
    .on(`turbolinks:load${AUTH_EVENT_NAMESPACE}`, initializeAuthPage)
const AUTH_EVENT_NAMESPACE = '.workplaceAuth'

function applyTheme(theme) {
    const isDark = theme === 'dark'
    const $darkModeButton = jQuery('#darkMode')

    jQuery('html').attr({
        'data-bs-theme': theme,
        'data-color-scheme': theme
    })
    $darkModeButton.attr('data-bs-theme', theme)
    $darkModeButton.find('span').text(
        $darkModeButton.attr(isDark ? 'data-lightmode-text' : 'data-darkmode-text')
    )
    $darkModeButton.find('i')
        .toggleClass('ico-sun-light-outline', isDark)
        .toggleClass('ico-moon-dark-outline', !isDark)

    if (window.gon) window.gon.cwwTheme = theme
}

function initializePasswordStrengthChecker() {
    const $passwordInput = jQuery('input[id*="password"]:not([id*="confirmation"]):not([class*="skip-checker"])')
    const $passwordConfirmationInput = jQuery('input[id*="password_confirmation"]')
    const $tooltip = jQuery('#passwordStrengthTooltip')
    const $bar = jQuery('#passwordStrengthBar')
    const $confirmationRule = $tooltip.find('.pwd-confirmation')
    const $strengthRules = $tooltip.find('li:not(.pwd-confirmation)')

    if (!$passwordInput.length || !$tooltip.length || !$bar.length) return

    const checkStrength = (password) => {
        const rules = {
            length: password.length >= 6,
            capital: /[A-Z]/.test(password),
            number: /[0-9]/.test(password),
            special: /[^A-Za-z0-9]/.test(password)
        }
        const passed = Object.values(rules).filter(Boolean).length
        let width = (passed / 4) * 100

        if (password.length > 0 && width === 0) width = 12

        const color = ['var(--bs-danger)', 'var(--bs-warning)', 'var(--bs-warning)', 'var(--bs-success)'][passed - 1] || 'var(--bs-danger)'
        $bar.css({ width: `${width}%`, backgroundColor: color })

        Object.entries(rules).forEach(([rule, rulePassed]) => {
            $tooltip.find(`.rule-${rule}`).toggleClass('active', rulePassed)
        })
    }

    const showTooltip = ($input) => {
        $tooltip
            .removeClass('d-none')
            .css({ top: 'calc(100% + 0.5rem)', left: 0, width: '100%', position: 'absolute' })
            .appendTo($input.closest('.form-group'))
    }

    $passwordInput
        .off(`input${AUTH_EVENT_NAMESPACE} focus${AUTH_EVENT_NAMESPACE}`)
        .on(`input${AUTH_EVENT_NAMESPACE} focus${AUTH_EVENT_NAMESPACE}`, (event) => {
            const $input = jQuery(event.currentTarget)

            $bar.parent().removeClass('d-none')
            $strengthRules.removeClass('d-none')
            $confirmationRule.addClass('d-none')
            checkStrength($input.val())
            showTooltip($input)
        })

    $passwordConfirmationInput
        .off(`input${AUTH_EVENT_NAMESPACE} focus${AUTH_EVENT_NAMESPACE}`)
        .on(`input${AUTH_EVENT_NAMESPACE} focus${AUTH_EVENT_NAMESPACE}`, (event) => {
            const $input = jQuery(event.currentTarget)
            const original = $passwordInput.val()
            const confirmation = $input.val()

            if (!original) return

            $bar.parent().addClass('d-none')
            $strengthRules.addClass('d-none')
            $confirmationRule.removeClass('d-none')

            if (confirmation && original === confirmation) {
                $confirmationRule
                    .addClass('active')
                    .find('.not-match').addClass('d-none').end()
                    .find('.do-match').removeClass('d-none')
            } else {
                $confirmationRule
                    .removeClass('active')
                    .find('.do-match').addClass('d-none').end()
                    .find('.not-match').removeClass('d-none')
            }

            showTooltip($input)
        })

    $passwordInput
        .add($passwordConfirmationInput)
        .off(`blur${AUTH_EVENT_NAMESPACE}`)
        .on(`blur${AUTH_EVENT_NAMESPACE}`, () => $tooltip.addClass('d-none'))
}

function initializeAuthPage() {
    const $darkModeButton = jQuery('#darkMode')
    const savedTheme = localStorage.getItem('last_CWWtheme_setting')
    const savedAccessibility = localStorage.getItem('last_cwwAccessibility_setting')

    if (savedTheme === 'light' || savedTheme === 'dark') applyTheme(savedTheme)

    if (savedAccessibility) {
        const togglerMap = { default: 'standard', small: 'smaller', big: 'bigger' }
        jQuery('html').attr('data-accessibility', savedAccessibility)
        jQuery('li #accessToggler').removeClass('current')
        jQuery(`#accessToggler[data-access-toggler="${togglerMap[savedAccessibility]}"]`).addClass('current')
    }

    $darkModeButton
        .off(`click${AUTH_EVENT_NAMESPACE}`)
        .on(`click${AUTH_EVENT_NAMESPACE}`, function(event) {
            event.preventDefault()
            const theme = jQuery('html').attr('data-bs-theme') === 'dark' ? 'light' : 'dark'
            applyTheme(theme)
            localStorage.setItem('last_CWWtheme_setting', theme)
        })

    jQuery('li #accessToggler')
        .off(`click${AUTH_EVENT_NAMESPACE}`)
        .on(`click${AUTH_EVENT_NAMESPACE}`, function(event) {
            event.preventDefault()
            const accessValueMap = { smaller: 'small', standard: 'default', bigger: 'big' }
            const toggler = jQuery(this).attr('data-access-toggler')
            const accessibility = accessValueMap[toggler] || 'default'

            jQuery('li #accessToggler').removeClass('current')
            jQuery(this).addClass('current')
            jQuery('html').attr('data-accessibility', accessibility)
            localStorage.setItem('last_cwwAccessibility_setting', accessibility)
        })

    jQuery('[id="showPassword"]')
        .off(`click${AUTH_EVENT_NAMESPACE}`)
        .on(`click${AUTH_EVENT_NAMESPACE}`, function() {
            const $input = jQuery(jQuery(this).attr('toggle'))
            jQuery(this).toggleClass('fa-eye-slash fa-eye')
            $input.attr('type', $input.attr('type') === 'password' ? 'text' : 'password')
        })

    initializePasswordStrengthChecker()

    jQuery('input, textarea').each(function() {
        const $input = jQuery(this)
        if (!$input.prop('required') && $input.val() !== '') $input.addClass('notempty')
    })

    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(element) {
        window.bootstrap.Tooltip.getOrCreateInstance(element)
    })

    jQuery('.loader').fadeOut()
    jQuery('#preloader').delay(150).fadeOut('slow')
}

jQuery(document)
    .off(`turbolinks:load${AUTH_EVENT_NAMESPACE}`)
    .on(`turbolinks:load${AUTH_EVENT_NAMESPACE}`, initializeAuthPage)
